import { UiEvent } from '../utils/ui-event';

export class ViewTracking {
	constructor() {
		const elements: NodeListOf<HTMLElement> = document.querySelectorAll(
			'.wp-block-cover[data-bi-subcategory][data-bi-target-id],.wp-block-group[data-bi-subcategory][data-bi-target-id]'
		);

		const observer: IntersectionObserver = new IntersectionObserver(this.observerCallback, {
			root: null,
			rootMargin: '0px',
			threshold: [0.25],
		});

		elements.forEach((item: HTMLElement) => observer.observe(item));
	}

	private observerCallback = (
		entries: IntersectionObserverEntry[],
		observer: IntersectionObserver
	): void => {
		entries.forEach((entry: IntersectionObserverEntry) => {
			if (entry.isIntersecting) {
				const target: HTMLElement = entry.target as HTMLElement;
				UiEvent.trackUIEvent(
					target.dataset.biSubcategory,
					target.dataset.biTargetId,
					'view'
				);
				observer.unobserve(target);
			}
		});
	};
}
